import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "../../../molecules";
import { Field, Formik } from "formik";
import { selectOrganizationsFilters } from "../../../../pages/Organizations";
import { actions } from "../../../../pages/Organizations/organizations.reducers";
import { actions as modalActions } from "../../Modal/modal.reducers";
import { EMPTY_STRING, ONE } from "../../../../constants";

const { setSelectedModal } = modalActions;

const FilterOrganizationsModal = () => {
  const organizationsFilters = useSelector(selectOrganizationsFilters);
  const { setOrganizationsFilters } = actions;
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(setSelectedModal());
  }, [dispatch]);

  const handleSubscriptionTypeFilters = useCallback(
    (value) => {
      dispatch(
        setOrganizationsFilters({
          ...organizationsFilters,
          subscriptionType: value.subscriptionType,
          page: ONE,
        })
      );
      handleClose();
    },
    [dispatch, handleClose, organizationsFilters, setOrganizationsFilters]
  );

  return (
    <Modal
      title={"Select subscription type"}
      subtitle={"Please select an option given below"}
      handleReset={handleClose}
      handleClose={handleClose}
    >
      <Formik
        initialValues={{
          subscriptionType: organizationsFilters.subscriptionType,
        }}
      >
        {({ values }) => (
          <div className="flex mx-5 justify-between  my-5">
            <Field
              as="select"
              name="subscriptionType"
              className=" rounded text-sm font-medium text-black-50 w-56"
            >
              <option value={EMPTY_STRING}>None</option>
              <option value="free">Free</option>
              <option value="paid">Paid</option>
            </Field>

            <button
              className="btn btn-primary "
              type="submit"
              onClick={() => handleSubscriptionTypeFilters(values)}
            >
              Filter
            </button>
          </div>
        )}
      </Formik>
    </Modal>
  );
};

export default FilterOrganizationsModal;
